import { createFileRoute } from '@tanstack/react-router';

import { FieldMap } from '@fields/feature';

export const Route = createFileRoute('/_app/fields_/$fieldId/')({
  component: FieldMap,
});
